import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, share } from 'rxjs/operators';
import { SharedService } from '../_shared/shared.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private totalRequests = 0;

    constructor(private shared: SharedService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const showLoad = !(request.body && request.body.hideLoader) && !request.params.get("hideLoader") 
        //console.log(request)
        if (showLoad) {
            this.totalRequests++;
            this.shared.setLoading(true);
        }
        const login = this.shared.login;
        if (login && login.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${login.token}`,
                    DeviceType: this.shared.deviceType
                }
            });
        }

        if (showLoad)
            return next.handle(request).pipe(
                finalize(() => {
                    this.totalRequests--;
                    if (this.totalRequests === 0) {
                        this.shared.setLoading(false);
                    }
                })
            );
        else
            return next.handle(request)
    }
}